import { ROUTES, RouteName } from '@/constants';
import replacePath from './replacePath.utils';

// Paths come from ROUTES rather than a literal, so the section can be renamed in one place.
export const getBlogHubPath = () => ROUTES[RouteName.Blog].path;

export const getBlogPostPath = (slug: string) => replacePath(RouteName.BlogPost, [slug]);

/** Hub URL with the listing state in the query string; page 1 stays bare so it shares the hub's canonical. */
export const buildBlogPath = ({ page, tag }: { page?: number; tag?: string | null } = {}) => {
  const params = new URLSearchParams();
  if (tag) params.set('tag', tag);
  if (page && page > 1) params.set('page', String(page));
  const queryString = params.toString();

  return `${getBlogHubPath()}${queryString ? `?${queryString}` : ''}`;
};
